<template>
  <b-modal hide-footer id="splitPayments" ref="splitPayments" title="Split Payments">
    <div>
      <div class="row border-bottom pb-2 mb-2">
        <div class="col-8">
          <span class="font-weight-semi-bold">PAYMENT MODE</span>
        </div>
        <div class="col-4 text-center">
          <span class="font-weight-semi-bold">AMOUNT</span>
        </div>
      </div>

      <!-- LOOP THIS DIV FOR DIFFERENT PAYMENT METHODS -->
      <div
        v-for="(singlePayment,singlePaymentIndex) in paymentModesArray"
        :key="singlePaymentIndex"
        class="col-12"
      >
        <div class="row py-2">
          <div class="col-8 align-self-center">
            <span>{{singlePayment.pm_payment_mode}}</span>
          </div>
          <div class="col-4">
            <input
              class="btn-transparent rounded border py-2 w-100"
              :value="singlePayment.amount"
              type="text"
              :id="`${singlePaymentIndex}_split_amount`"
              :disabled="singlePayment.pm_id == 11"
              @click="onClickInputHandler(singlePayment)"
              @input="onChangePaymentValue({index: singlePaymentIndex, value: $event.target.value})"
            />

              <VkeyboardFloat
                :ID="`${singlePaymentIndex}_split_amount`"
                :onClickFun="() => onClickShowKeyboard(singlePayment)"
              />
              <Vkeyboard
                :inputName="`${singlePaymentIndex}_split_amount`"
                :showOrHide="singlePayment.keyboardActive"
                :initialValue="String(singlePayment.amount)"
                :keyBoardType="'numeric'"
                @onChangeEvent="() => {}"
                @onKeyEnter="onCloseKeyboard(singlePayment)"
                @changeKeyboardInput="onChangePaymentValue({
                    index: singlePaymentIndex,
                    value: $event,
                  })"
                @onClickClose="onCloseKeyboard(singlePayment)"
              />
          </div>
        </div>
      </div>
      <!-- <div class="col-12">
          <div class="row py-2">
            <div class="col-8 align-self-center">
              <span>Credit Card</span>
            </div>
            <div class="col-4">
              <button class="btn-transparent rounded border py-2 w-100">100</button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row py-2">
            <div class="col-8 align-self-center">
              <span>Cash Card</span>
            </div>
            <div class="col-4">
              <button class="btn-transparent rounded border py-2 w-100">100</button>
            </div>
          </div>
      </div>-->

      <div class="col-12 border-top mt-2">
        <div class="row py-2">
          <div class="col-8">
            <span>Total</span>
          </div>
          <div class="col-4 text-center">
            <span class="font-weight-semi-bold">{{ total_payment }}</span>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row pb-2">
          <div class="col-8">
            <span>Total amount to be paid:</span>
          </div>
          <div class="col-4 text-center">
            <span class="font-weight-semi-bold">{{ parseFloat(totalAmount).toFixed(2) }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 border-top mt-2">
        <div class="row py-2">
          <div class="col-8">
            <span>Offer Price</span>
          </div>
          <div class="col-4 text-center">
            <span class="font-weight-semi-bold">-{{ getOfferPrice || getloyaltyAmount }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 border-top">
        <div class="row py-3">
          <div class="col-8">
            <span class="fs-16 font-weight-semi-bold">Balance Amount</span>
          </div>
          <div class="col-4 text-center">
            <strong class="fs-16">{{ parseFloat(balance_amount).toFixed(2) }}</strong>
          </div>
        </div>
      </div>

      <div class="col-12 pt-3 text-center">
        <button @click="onPayViaSplitMethod()" class="btn-blue-lg px-5">Submit</button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
export default {
  components: {
    Vkeyboard,
    VkeyboardFloat
  },
  props: {
    showModal: Boolean,
  },
  data() {
    return {};
  },
  watch: {
    showModal(newval) {
      this.$bvModal.show("splitPayments");
    },
  },
  computed: {
    paymentModesArray() {
      let paymentModesTemp = []
        this.paymentModes.map((x) => {
          x['keyboardActive'] = false;
            paymentModesTemp.push(x)
        })

      return paymentModesTemp
    },
    total_payment() {
      return this.paymentModes.reduce(
        (acc, { amount }) => acc + parseFloat(amount),
        0
      );
    },
    balance_amount() {
      if (this.total_payment > 0) {
        return this.totalAmount - this.total_payment;
      } else {
        return 0;
      }
    },

    totalAmount() {
      return (
        this.selectedFnBItemsTotalPrice +
        this.TotalAdditionalTaxes +
        this.selectedAddonsTotalPrice +
        this.customizationTotalPrice +
        this.customizationTaxesPrice +
        this.$store.getters.TOTAL_AMOUNT -
        this.getOfferPrice -
        this.getloyaltyAmount
      );
    },

    ...mapGetters([
      "getOfferPrice",

      "paymentModes",
      "selectedPaymentMode",

      "getloyaltyAmount",

      //
      "cashCards",
      "selectedCashCard",
      "paid_amount",
      "paidflag",
      "selectedAddonsTotalPrice",
      "customizationTotalPrice",
      "customizationTaxesPrice",
      "selectedFnBItemsTotalPrice",
      "TotalAdditionalTaxes",
    ]),
  },
  mounted() {
  },
  methods: {
    ...mapActions(["onChangePaymentValue"]),
    onCloseKeyboard(pm) {
      pm['keyboardActive'] = false;
      this.$forceUpdate();
    },
    onClickShowKeyboard(pm) {
      this.paymentModesArray.map((x) => {
        if(pm.pm_id !== x.pm_id) {
          x['keyboardActive'] = false;
        }
      })

      pm['keyboardActive'] = true;
      this.$forceUpdate();
    },
    onClickInputHandler(pm) {
      if(this.paymentModesArray.some((y) => y.keyboardActive == true)) {
        this.paymentModesArray.map((x) => {
        if(pm.pm_id !== x.pm_id) {
          x['keyboardActive'] = false;
        }
      })
       pm['keyboardActive'] = !pm['keyboardActive'];
       this.$forceUpdate();
      }
    },
    onPayViaSplitMethod() {
      if (
        parseFloat(this.total_payment).toFixed(2) ==
        parseFloat(this.totalAmount).toFixed(2)
      ) {
        this.$refs["splitPayments"].hide();
        this.paymentshowbutton = false;
        this.isUnpaidBooking = false;
        this.showbutton = false;
        const { user_id } = this.secureStore.get("USINFO");
        if (this.$store.getters.TOTAL_AMOUNT > 0) {
          console.log("in fnbbox :::::::::::::::::>> ");
          this.$store.dispatch("onBoxOfficeAndFnBOrderSubmit", {
            isSplitPayment: true,
          });
        } else {
          this.$store.dispatch("onOrderSubmit", { isSplitPayment: true });
        }
        // this.$store.dispatch("insertBoxOfficeTransaction", {
        //   reservationId: this.reservationId,
        //   isSplitPayment: true
        // });
      } else {
        this.$toasted.show("Payment Value is not same as Total Amount");
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/PosFnbContainer/fnbSplitPayment.vue